import React from 'react'
import { LinkOutlined } from '@ant-design/icons'
import { Button, Form, Input, Typography } from 'antd'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'

import { antFormItemNamePropType } from '../../prop-types'
import {
  formatFormLabel,
  getFormItemLabelAboveConfiguration,
} from '../../utils'

const FormInputContent = ({ value, onChange, isSearch, link, ...rest }) => {
  if (isSearch) {
    return <Input.Search {...rest} value={value} onChange={onChange} />
  }

  if (!isEmpty(link)) {
    return (
      <Input.Group style={{ display: 'flex' }}>
        <Input {...rest} value={value} onChange={onChange} />
        <a href={link} rel="noreferrer" target="_blank">
          <Button aria-label="link" icon={<LinkOutlined />} shape="square" />
        </a>
      </Input.Group>
    )
  }

  return <Input {...rest} value={value} onChange={onChange} />
}

FormInputContent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  isSearch: PropTypes.bool,
  link: PropTypes.string,
}

FormInputContent.defaultProps = {
  value: undefined,
  onChange: undefined,
  isSearch: false,
  link: undefined,
}

const FormInput = ({
  name,
  label,
  rules,
  labelAbove,
  showColon,
  isSearch,
  link,
  ...rest
}) => (
  <Form.Item
    labelCol={getFormItemLabelAboveConfiguration(labelAbove)}
    fieldKey={name}
    name={name}
    label={
      <Typography.Text>{formatFormLabel(label, showColon)}</Typography.Text>
    }
    rules={rules}
  >
    <FormInputContent isSearch={isSearch} link={link} {...rest} />
  </Form.Item>
)

FormInput.propTypes = {
  name: antFormItemNamePropType.isRequired,
  label: PropTypes.string,
  labelAbove: PropTypes.bool,
  rules: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  ),
  showColon: PropTypes.bool,
  isSearch: PropTypes.bool,
  link: PropTypes.string,
}

FormInput.defaultProps = {
  label: '',
  rules: undefined,
  labelAbove: false,
  showColon: true,
  isSearch: false,
  link: undefined,
}

export default FormInput
